import Headroom from '../../vendor/headroom';

let headroom;

export default () => {
  if (headroom) {
    headroom.destroy();
  }

  const $headroom = $('[data-headroom]');  
  let offset = 0;
  let type = $headroom.data('headroom');
  
  if (window.theme.breakpoints.current === 'mobile' || window.theme.breakpoints.current === 'tablet') {
    type = $headroom.data('headroomMobile');
  }

  switch (type) {
    case 'preheader':
      offset = $('[data-pre-header]').height();
      break;
    case 'header':
      offset = $('[data-header]').height();
      break;
    case 'both':
      offset = $headroom.height();
      break;
  }

  if (offset > 0) {
    headroom = new Headroom($('[data-headroom]')[0], { offset });
    headroom.init();
  }
};